import React from 'react';
import {Map} from 'immutable';
import {AuthoringSubjectModelV1} from 'resources/augmented/AuthoringSubject/AuthoringSubjectModel.v1';

interface Props {
  item: AuthoringSubjectModelV1 | typeof Map;
}

export default function SupplementSubjectDropdownTemplate({item}: Props) {
  return (
    <div className='subject-option-template'>
      <small>{item.getDomain()}</small>
      <br />
      {item.getName()}
    </div>
  );
}
